













































import {
    Component,
    Vue,
} from 'vue-property-decorator';
import {
    Prop,
} from 'vue-property-decorator';
import * as types from '@/mutation-types';
import { debug } from 'util';

@Component
export default class DayCell extends Vue {
    @Prop() public item!: any;

    public show() {
        if (this.canShow) {
            window.eventBus.$emit(types.SHOW_REGULARIZATION_WINDOW, this.item);
        }
    }

    get canShow() {
        return (this.item && !this.item.isLocked && this.item.status !== 10 && this.item.today !== true);
    }

    get bgColor() {
        if (this.item) {
            if (this.item.status && this.item.status === 10 && this.item.isPreviousCalender !== true) {
                return 'green lighten-4';
            } else if (this.item.status &&
                (this.item.status === 1 || this.item.status === 2 || this.item.status === 9)
                && this.item.isPreviousCalender !== true
                ) {
                return 'grey lighten-4';
            } else if (this.item.isPreviousCalender === true) {
                return 'white';
            } else if (this.item.status &&
                (this.item.status === 3 ||
                    this.item.status === 4 ||
                    this.item.status === 6 ||
                    this.item.status === 7 ||
                    this.item.status === 8)
                    && this.item.isPreviousCalender !== true
                    ) {
                return 'red lighten-5';

            } else if (this.item.hasLessWorkingHours) {
                return 'red lighten-4';
            }
        }
        return '';
    }

    get txtColor() {
        if (this.item) {
            if (this.item.lopDays) {
                return 'red--text';
            } else if (this.item.status && (this.item.status === 1 || this.item.status === 2)) {
                return 'indigo--text';
            } else if (this.item.status &&
                (this.item.status === 3 ||
                    this.item.status === 4 ||
                    this.item.status === 6 ||
                    this.item.status === 7 ||
                    this.item.status === 8)) {
                return 'orange--text';
            }
        }
        return '';
    }
}
